import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useFieldRegistry } from "@/hooks/admin/useFieldRegistry";
import { GroupedFieldForm } from "@/components/shared/fields/GroupedFieldForm";
import type { EntityType } from "@/types/fieldRegistry";

// Hook para verificar se há contexto de formulário disponível
const useFormContextSafe = () => {
  try {
    return useFormContext();
  } catch (error) {
    return null;
  }
};

interface OrganizationCustomFieldsFormProps {
  customData?: Record<string, any>;
  pageType: 'deals' | 'companies' | 'leads' | 'activities';
  onCustomDataChange?: (customData: Record<string, any>) => void;
}

export function OrganizationCustomFieldsForm({ customData = {}, pageType, onCustomDataChange }: OrganizationCustomFieldsFormProps) {
  const { groupedFields, isLoading } = useFieldRegistry(pageType as EntityType);
  const formContext = useFormContextSafe();
  const [fieldValues, setFieldValues] = useState<Record<string, any>>(customData);

  useEffect(() => {
    if (customData && Object.keys(customData).length > 0) {
      setFieldValues(customData);
    }
  }, [customData]);

  const handleFieldChange = (fieldName: string, value: any) => {
    const newValues = { ...fieldValues, [fieldName]: value };
    setFieldValues(newValues);

    if (formContext) {
      formContext.setValue('custom_data', newValues);
    }

    if (onCustomDataChange) {
      onCustomDataChange(newValues);
    }
  };

  if (isLoading) {
    return (
      <div className="space-y-4">
        <div className="h-4 bg-muted animate-pulse rounded" />
        <div className="h-10 bg-muted animate-pulse rounded" />
        <div className="h-4 bg-muted animate-pulse rounded" />
        <div className="h-10 bg-muted animate-pulse rounded" />
      </div>
    );
  }

  return (
    <GroupedFieldForm
      groupedFields={groupedFields}
      values={{ custom_data: fieldValues }}
      onChange={handleFieldChange}
      visibility="add_form"
      customOnly
    />
  );
}
